import { useContext } from 'react';
import { Box, Button, Link, Tabs } from '@mui/material';
import { Grid } from '@mui/system';
import { CONTACT_US_LINK, PRIVACY_POLICY_LINK } from 'common/constants/process-management/processManagement';
import { TaskContext } from 'context/TaskContext';
import { TaskContextType } from 'context/TaskContext/types';
import HowDoIUseThisDocumentsUploadSection from 'pages/RequestDocuments/components/HowDoIUseThisDocumentsUploadSection/HowDoIUseThisDocumentsUploadSection';
import FirmInfoHeader from './components/FirmInfoHeader/FirmInfoHeader';
import PortalAuthButton from './components/PortalAuthButton/PortalAuthButton';
import ReportDateTextField from './components/ReportDateTextField';
import TaskExpirationDate from './components/TaskExpirationDate/TaskExpirationDate';
import { StyledTab, useStyles } from './styles';



const ProcessManagementHeader = () => {
  const { task, isMobile } = useContext(TaskContext) as TaskContextType;
  const { task: taskData } = task;
  const classes = useStyles();
  return (
    <Box 
      position="sticky" 
      top={0} 
      zIndex={999}
      sx={{ 
        backgroundColor: 'background.paper',
        borderBottom: '1px solid',
        borderColor: 'divider',
        ml: '4rem',
      }}
    >
      <Box px={2} minHeight="8rem">
        <Grid container className={classes.appBar} spacing={2}>
          <Grid
            size={{
              xs: 12,
              sm: 3,
            }}
            className={classes.menuItems}
            style={{
              order: 1,
            }}>
            <FirmInfoHeader taskData={taskData} />
          </Grid>
          <Grid 
            size={{ 
              xs: 12, 
              sm: 2 
            }} 
            style={{
              order: 2,
              alignItems: 'center',
              display: 'grid',
              justifyContent: 'center',
            }}>
            <Box>
              <HowDoIUseThisDocumentsUploadSection />
            </Box>
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 3,
            }}
            style={{
              order: 3,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}>
            <TaskExpirationDate />
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 2,
            }}
            style={{
              order: 4,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}>
            <Box>
              <ReportDateTextField value={taskData?.measurement_date?.date} />
            </Box>
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 2,
            }}
            style={{
              order: 5,
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
            }}>
            <PortalAuthButton />
          </Grid>
        </Grid>
      </Box>

      <Box 
        className={classes.bottomSection}
      >
        <Grid container alignItems="center" justifyContent="space-between" px={2}>
          <Grid>
            <Tabs value={0}>
              <StyledTab label="SECURE PORTAL" />
            </Tabs>
          </Grid>
          <Grid>
            <Box display="flex" gap={2} justifyContent="space-between">
              <Link href={CONTACT_US_LINK}>
                <Button 
                  size="small" 
                  sx={{ 
                    color: 'white',
                    textTransform: 'none',
                    '&:hover': { backgroundColor: 'action.hover' }
                  }}
                >
                Contact Us
                </Button>
              </Link>
              <Link href={PRIVACY_POLICY_LINK}>
                <Button 
                  size="small" 
                  sx={{ 
                    color: 'white',
                    textTransform: 'none',
                    '&:hover': { backgroundColor: 'action.hover' }
                  }}
                >
                Privacy Policy
                </Button>
              </Link>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default ProcessManagementHeader;
